/**
 * connectForm directive
 *
 * this directive binds the state to the reactive form
 *
 * as long as the form field has the same name as the state.feature
 */

import { Directive, Input } from '@angular/core'
import { FormGroupDirective } from '@angular/forms'

@Directive({ selector: '[connectForm]' })
export class ConnectFormDirective {
  @Input('connectForm')
  set data(val: any) {
    if (val) {
      this.formGroupDirective.form.patchValue(val)
      this.formGroupDirective.form.markAsPristine()
    }
  }
  constructor(private formGroupDirective: FormGroupDirective) {}
}
